<template>
  <NSeparator label="OR" class="mx-2" />
</template>
